// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".legacy." + {"686":"d85d735a6121923eb5be","688":"38de1540adcf2b818386"}[chunkId] + ".js";
};